const routes = [
  {
    path: '/reports',
    name: 'reports',
    component: () => import(/* webpackChunkName: "ReportsPage" */ './views/ReportsPage.vue'),
    meta: { pageNameEn: 'Reports' },
  },
];

export default routes;
